import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { GoogleLogo } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      if (data.token) localStorage.setItem("auth_token", data.token);
      setUser(data.user);
      navigate("/book");
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2 max-w-7xl mx-auto" data-testid="register-page">
      <div className="hidden lg:flex flex-col justify-between border-r hairline p-12 fade-in">
        <div>
          <p className="overline">— Criar conta</p>
          <h1 className="font-display text-6xl mt-6 leading-[0.95] text-[#003D4C]">
            Comece o seu <br /> <span className="text-[#003D4C]/55">ciclo.</span>
          </h1>
        </div>
        <p className="text-sm text-[#003D4C]/65 max-w-xs">
          Reserva imediata, histórico e pagamento seguro num só lugar.
        </p>
      </div>

      <div className="flex items-center justify-center p-8 lg:p-16">
        <form onSubmit={submit} className="w-full max-w-md fade-in d-1" data-testid="register-form">
          <h2 className="font-display text-4xl mb-2 text-[#003D4C]">Criar conta</h2>
          <p className="text-sm text-[#003D4C]/65 mb-8">
            Já tem conta? <Link to="/login" className="text-[#BE3A34] hover:underline" data-testid="link-login">Entrar</Link>
          </p>

          <button type="button" onClick={googleLogin} className="btn-ghost w-full py-3 mb-4 flex items-center justify-center gap-3" data-testid="google-register-btn">
            <GoogleLogo size={18} weight="light" /> Continuar com Google
          </button>

          <div className="flex items-center gap-3 my-6">
            <div className="h-px bg-[#003D4C]/12 flex-1" />
            <span className="overline">ou email</span>
            <div className="h-px bg-[#003D4C]/12 flex-1" />
          </div>

          <label className="overline block mb-2">Nome</label>
          <input type="text" required value={name} onChange={(e) => setName(e.target.value)}
            className="field mb-4" data-testid="register-name" placeholder="O seu nome" />

          <label className="overline block mb-2">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="field mb-4" data-testid="register-email" placeholder="voce@email.com" />

          <label className="overline block mb-2">Palavra-passe</label>
          <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
            className="field" data-testid="register-password" placeholder="Mínimo 6 caracteres" />

          {err && <p className="text-sm text-[#BE3A34] mt-3" data-testid="register-error">{err}</p>}

          <button type="submit" disabled={loading} className="btn-hot w-full py-3 mt-6" data-testid="register-submit">
            {loading ? "A criar…" : "Criar conta"}
          </button>
        </form>
      </div>
    </div>
  );
}
